export default __webpack_public_path__ + "static/media/chees.d9e514c0.png";